module.exports = __webpack_public_path__ + "static/media/peroni_bottiglia_peroni.c36c29a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni_bottiglia_peroni.jpg
// module id = 807
// module chunks = 0